import { useCallback, useEffect, useState } from "react";
import { onStartTour } from "./tourBus";

/* Reusable per-page tour state: auto-opens once (unless already completed),
   persists completion to localStorage (mmp_-prefixed, following the
   convention in CityDetailLimitModal.js), and can be re-opened from
   anywhere via tourBus.startTour(pageKey) regardless of the stored flag. */
export default function useTour(pageKey, { autoStart = true } = {}) {
  const storageKey = `mmp_tour_completed_${pageKey}`;
  const [isOpen, setIsOpen] = useState(false);

  // Auto-open once (unless already completed). Re-runs when `autoStart`
  // flips true so a tour gated to a specific tab/condition starts the first
  // time that tab becomes active — not only on initial mount.
  useEffect(() => {
    if (!autoStart) return;
    let seen = false;
    try {
      seen = localStorage.getItem(storageKey) === "1";
    } catch (e) {}
    if (!seen) setIsOpen(true);
  }, [autoStart, storageKey]);

  useEffect(() => onStartTour(pageKey, () => setIsOpen(true)), [pageKey]);

  const finish = useCallback(() => {
    setIsOpen(false);
    try {
      localStorage.setItem(storageKey, "1");
    } catch (e) {}
  }, [storageKey]);

  return { isOpen, finish };
}
